import { render, staticRenderFns } from "./RecentNotifications.vue?vue&type=template&id=6d9ec2a0&scoped=true&"
import script from "./RecentNotifications.vue?vue&type=script&lang=js&"
export * from "./RecentNotifications.vue?vue&type=script&lang=js&"
import style0 from "./RecentNotifications.vue?vue&type=style&index=0&id=6d9ec2a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ec2a0",
  null
  
)

export default component.exports